export class DynamicColumnsActions {
    editar?: boolean;
    eliminar?: boolean;
}